import { createContext } from "react";
import { DeviceType } from "./getDeviceType";

export const deviceTypeContext = createContext<DeviceType | null>(null);
export const DeviceTypeProvider = deviceTypeContext.Provider;
